import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router) { }

  toRouterLink(route: (string | number)[]): string {
    let link = '';
    route.forEach((part) => {
      link += `/${part}`;
    });
    return link;
  }

  navigate(parts: string[], queryParams?: Object) {
    this.router.navigate(parts, {queryParams});
  }

  // replaceUrl so the current route (e.g. a redirect resolver) is dropped from browser history.
  navigateReplace(parts: string[], queryParams?: Object) {
    this.router.navigate(parts, {queryParams, replaceUrl: true});
  }

  getForgotPasswordRoute(): string[] {
    return ['forgot-password'];
  }

  getDealDeskRoute(): string[] {
    return ['deal-desk'];
  }

  getDealDeskViewContractRoute(quoteRequestId: string): string[] {
    return [...this.getDealDeskRoute(), 'contract', quoteRequestId];
  }

  getDashboard(): string[] {
    return ['dashboard'];
  }

  getContracts(): string[] {
    return ['contracts'];
  }

  getBookedContracts(): string[] {
    return [...this.getContracts(), 'booked'];
  }

  getBiddingBase(): string[] {
    return ['bidding'];
  }

  getBidHistory(): string[] {
    return ['bidding', 'history'];
  }

  getWinLossReport(rateCheckId: string): string[] {
    return [...this.getBidHistory(), rateCheckId];
  }

  getBidRequest(quoteRequestId: string): string[] {
    return [...this.getBiddingBase(), 'request', quoteRequestId];
  }

  getPricingSummary(quoteRequestId: string): string[] {
    return [...this.getBiddingBase(), 'pricing-summary', quoteRequestId];
  }

}
